enum LocalStorageKey {
  token = "token",
  email = "email",
  expiration = "expiration",
  firebaseToken = "firebaseToken",
}

export const storage = {
  saveAuthentication: (token: string, email: string, firebaseToken?: string) => {
    localStorage.setItem(LocalStorageKey.token, token);
    localStorage.setItem(LocalStorageKey.email, email);
    if (firebaseToken) {
      localStorage.setItem(LocalStorageKey.firebaseToken, firebaseToken);
    }
  },
  deleteAuthentication: () => {
    localStorage.removeItem(LocalStorageKey.token);
    localStorage.removeItem(LocalStorageKey.email);
    localStorage.removeItem(LocalStorageKey.firebaseToken);
  },
  getToken: () => {
    return localStorage.getItem(LocalStorageKey.token);
  },
  getEmail: () => {
    return localStorage.getItem(LocalStorageKey.email);
  },
  getFirebaseToken: () => {
    return localStorage.getItem(LocalStorageKey.firebaseToken);
  },
  getExpiration: () => {
    return localStorage.getItem(LocalStorageKey.expiration);
  }
};
